import { Common } from "../Components/Canvas";
import Utility from "./utility";

export const setColorHandler = (ev) => {
  let colors = document.querySelectorAll(".colour");
  for (let color of colors) {
    color.classList.remove("active");
    if (color === ev.target) {
      color.classList.add("active");
    }
  }
};

export const setWidthHandler = (ev) => {
  let widths = document.querySelectorAll(".width");
  for (let width of widths) {
    width.classList.remove("active");
    if (width === ev.target) {
      width.classList.add("active");
    }
  }
};

export const postMessageToParentWindow = () => {
  let main_canvas = document.querySelector(".main_canvas");
  let temp_canvas = document.createElement("canvas");
  let temp_ctx = temp_canvas.getContext("2d");
  let main_width = Common.canvas_width;
  let main_height = Common.canvas_height;
  let bg_canvas = document.createElement("canvas");
  let bg_ctx = bg_canvas.getContext("2d");

  // set white background;
  bg_canvas.width = main_width;
  bg_canvas.height = main_height;
  bg_ctx.fillStyle = "#FFFFFF";
  bg_ctx.fillRect(0, 0, main_width, main_height);

  temp_canvas.width = main_width;
  temp_canvas.height = main_height;

  temp_ctx.drawImage(bg_canvas, 0, 0, main_width, main_height);
  temp_ctx.drawImage(main_canvas, 0, 0);

  window.parent.postMessage({
    "action": "save",
    "image": temp_canvas.toDataURL("image/png")
  })
}

export const saveImage = () => {
  let main_canvas = document.querySelector(".main_canvas");
  let temp_canvas = document.createElement("canvas");
  let temp_ctx = temp_canvas.getContext("2d");
  let link = document.createElement("a");
  let main_width = Common.canvas_width;
  let main_height = Common.canvas_height;
  let bg_canvas = document.createElement("canvas");
  let bg_ctx = bg_canvas.getContext("2d");

  // set white background;
  bg_canvas.width = main_width;
  bg_canvas.height = main_height;
  bg_ctx.fillStyle = "#FFFFFF";
  bg_ctx.fillRect(0, 0, main_width, main_height);

  temp_canvas.width = main_width;
  temp_canvas.height = main_height;

  temp_ctx.drawImage(bg_canvas, 0, 0, main_width, main_height);
  temp_ctx.drawImage(main_canvas, 0, 0);

  let image = temp_canvas.toDataURL("image/png");
  // .replace("image/png", "image/octet-stream");

  link.download = "artwork.png";
  link.href = image;
  link.click();

  // let _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);

  // temp_canvas.toBlob((blob) => {
  //   console.log(blob);
  //   saveAs(blob, "pretty image.png");
  // });
};

export const uploadImage = (input) => {
  if (input.files && input.files[0]) {
    Utility.hideMenus();

    let reader = new FileReader();
    let chosenImgCont = document.querySelector(".chosenImageContainer");

    reader.readAsDataURL(input.files[0]); // convert to base64 string

    reader.onload = function (ev) {
      Common.newImage.src = ev.target.result;
      Common.newImage.onload = function () {
        chosenImgCont.classList.add("showImageContainer");

        let rect = document.querySelector(".rect");
        rect.style.background = `url(${ev.target.result}) center center / contain no-repeat`;

        // clear because it will still be there and trigger when choosing a sticker;
        Common.newImage.onload = null;
      };
    };
  }
};

export const changeToolColor = () => {
  let tools = document.querySelectorAll(".toolSizeButton");

  for (let tool of tools) {
    tool.style.background = `url()`;
    tool.style.backgroundColor = Common.color;
  }
};

export const changeGlitterColor = () => {
  let tools = document.querySelectorAll(".toolSizeButton");

  for (let tool of tools) {
    tool.style.backgroundColor = "";
    tool.style.background = `url(${Common.selectedGlitter})`;
  }
};

export const setColorBox = () => {
  if (!Common.selectedColor && !Common.selectedGlitter) return;

  let pickOptions = document.querySelector(".pickOptions");
  let rows = pickOptions.children;

  for (let row of rows) {
    let boxes = row.children;

    for (let box of boxes) {
      box.classList.remove("pathSelected");
    }
  }
  let selected = Common.selectedColor
    ? pickOptions.querySelector(
        `[data-path='${Common.selectedColor.dataset.path}']`
      )
    : pickOptions.querySelector(
        `[data-path='${Common.glitterID} ${Common.color}']`
      );

  if (selected) {
    selected.classList.add("pathSelected");
  }
};

export const animateSelectedTool = () => {
  let showImageContainer = document.querySelector(".showImageContainer");

  if (showImageContainer) return;

  let tools = document.querySelectorAll(".bot_tool");
  let tool_id = Common.selected_tool_id;
  let selected_tool = document.querySelector(`[data-toolid='${tool_id}']`);

  let tape_wrapper = document.querySelector(".tape_wrapper");

  if (
    (tool_id === "6" || tool_id === "8") &&
    Common.previous_selected_tool_id === "7"
  ) {
  } else {
    tape_wrapper.style.display = "none";
  }

  for (let tool of tools) {
    tool.style.transform = "translateY(0)";
    tool.style.transform = "scale(1)";
  }

  +tool_id > 5
    ? (selected_tool.style.transform = "scale(1.4) translateY(-25%)")
    : (selected_tool.style.transform = "translateY(-25%)");

  if (tool_id === "7") {
    tape_wrapper.style.display = "block";
  }
};

export const removeAnimations = () => {
  let tools = document.querySelectorAll(".bot_tool");

  for (let tool of tools) {
    tool.style.transform = "translateY(0)";
  }

  let tape_wrapper = document.querySelector(".tape_wrapper");
  let tape_canvas = document.querySelector(".tape_canvas");

  tape_wrapper.style.display = "none";
  tape_canvas.width = 1;
};
